<template>
<div></div>
</template>

<script>
export default {
name: "SwitchCell"
}
</script>

<style scoped>

</style>